import parse from 'html-react-parser'
import styles from './styles/intro.module.css'

const IntroHeading = ({ introHeading }) => <div className={styles.headerHeadingDiv}>{parse(introHeading)}</div>

export default IntroHeading
